import { connect } from 'react-redux';
import { compose, hoistStatics } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Footer from './Footer';

const mapStateToProps = state => ({
  showFooter: state.settings.subscriber.white_label ? state.settings.subscriber.show_footer : true,
});

const enhance = compose(
  connect(mapStateToProps),
  translate('portal'),
);

export default withRouter(hoistStatics(enhance)(Footer));



// WEBPACK FOOTER //
// ./src/containers/footer/index.js